// /src/store/modules/options.js
import CommonGetters from '@/store/common/getters'
import { apiGet, futureDate } from '@/services/API'
import { optionsStore } from '@/services/Storage'
import CustomAPI from '@/services/CustomAPIService'
import _isArray from 'lodash/isArray'

export const namespaced = true

export const state = {
  currentAPIRun: 0,
  nextAPIRun: 0,
  staleDataDate: 0,
  featuredRelationships: {
    data: [],
  },
  departments: {
    data: [],
  },
  globalResources: {
    data: [],
  },
  primaryMenu: {
    data: [],
  },
}

export const mutations = {
  SET_CURRENT_API_RUN(state, date) {
    state.currentAPIRun = date
  },
  SET_API_NEXT_RUN(state, date) {
    state.nextAPIRun = date
  },
  SET_API_STALE_DATA_DATE(state, date) {
    state.staleDataDate = date
  },
  SET_FEATURED_RELATIONSHIPS(state, data) {
    state.featuredRelationships = data
  },
  SET_DEPARTMENTS(state, data) {
    state.departments = data
  },
  SET_GLOBAL_RESOURCES(state, data) {
    state.globalResources = data
  },
  SET_PRIMARY_MENU_LINKS(state, data) {
    state.primaryMenu = data
  },
}

export const actions = {
  getAll({ dispatch, rootState }) {
    if (
      rootState.user.user !== null &&
      !dispatch('user/expire', null, { root: true })
    ) {
      return
    }
    dispatch('requestOptions')
  },
  async requestOptions({ commit, dispatch }, args = {}) {
    const apiRequests = optionsStore.apiRequests
    const varData = optionsStore.varData
    await Promise.all(
      Object.keys(varData).map(async key => {
        try {
          const config = varData[key]
          const stateItem = {}
          stateItem['data'] = config.data
          stateItem['title'] = config['title']
          stateItem['storeKey'] = config['storeKey']
          stateItem['titlePlural'] = config['titlePlural']
          commit(config.stateCommit, stateItem)

        } catch (err) {
          console.log(err)
        }
      }),
    )

    await Promise.all(
      Object.keys(apiRequests).map(async key => {
        const config = apiRequests[key]
        // console.log(apiRequests[key])
        try {
          // add published to arguments
          const res = await CustomAPI.customEndpoint(config.apiPath)
          if (res.status == 200) {
            args['include'] = res.data.join(',')
            // console.log(typeof res.data)
            // console.log(_isArray(res.data))
            // console.log(res.data.join(','))
            args['orderby'] = 'include'
            const posts = await apiGet(config.postKey, args)
            if (posts.status == 200) {
              const stateItem = {}
              stateItem['data'] = posts.data
              stateItem['title'] = config['title']
              stateItem['storeKey'] = config['storeKey']
              stateItem['postKey'] = config['postKey']
              stateItem['routePath'] = config['routePath']
              stateItem['titlePlural'] = config['titlePlural']
              commit(config.stateCommit, stateItem)
            }
          } else {
            // dispatch(
            //   'notification/add',
            //   {
            //     type: 'error',
            //     msg: `Request for ${config['titlePlural']} Failed: ERROR ${res.request.status}, ${res.request.statusText}`,
            //     closable: true,
            //     autoClose: true,
            //   },
            //   { root: true },
            // )
          }
          if (key == apiRequests.length - 1) {
            dispatch('updateAPIRunTimes')
          }
        } catch (err) {
          console.log(err)
          // dispatch(
          //   'notification/add',
          //   {
          //     type: 'error',
          //     msg: `Requests Failed: ${err}`,
          //     closable: true,
          //     autoClose: false,
          //   },
          //   { root: true },
          // )
        }
      }),
    )
  },

  updateAPIRunTimes({ commit }) {
    const requestDateTime = new Date().getTime()
    commit('SET_CURRENT_API_RUN', requestDateTime)
    commit('SET_API_NEXT_RUN', futureDate(requestDateTime))
    commit('SET_API_STALE_DATA_DATE', futureDate(requestDateTime, 43200)) // 43200 == 30 days
  },
}

export const getters = {
  ...CommonGetters,
  // getAllSessions: state => {
  //   const sessionItemConfigs = optionsStore.apiRequests.filter(
  //     item => item.learningType == 'session',
  //   )
  //   const collection = []
  //   let i = 0
  //   do {
  //     const item = state[sessionItemConfigs[i].storeKey].data
  //     collection.push(item)
  //     i++
  //   } while (i < sessionItemConfigs.length)
  //   return collection.flat()
  // },
  // getAllOfType: state => (stateType = 'session') => {
  //   const apiConfig = optionsStore.apiRequests.filter(
  //     item => item.learningType == stateType,
  //   )
  //   const collection = []
  //   let i = 0
  //   do {
  //     const item = state[apiConfig[i].storeKey].data
  //     collection.push(item)
  //     i++
  //   } while (i < apiConfig.length)
  //   return collection.flat()
  // },
  // getAllPosts: state => {
  //   const posts = optionsStore.apiRequests
  //   const collection = []
  //   let i = 0
  //   do {
  //     const item = state[posts[i].storeKey].data
  //     collection.push(item)
  //     i++
  //   } while (i < posts.length)
  //   return collection.flat()
  // },
  getOptionPosts: state => type => {
    const { data } = state[type]
    return data
  },
  findAllPostsByProp: (state, getters) => (array = [0], propKey = 'id') => {
    const collection = []
    let i = 0
    do {
      const item = getters['getAllPosts'].find(
        item => item[propKey] == array[i],
      )
      collection.push(typeof item != 'undefined' ? item : {})
      i++
    } while (i < array.length)
    return collection
  },
  getAllManditoryPosts: (state, getters) => {
    const { getAllPosts } = getters
    const output = getAllPosts.filter(item => {
      if (item.acf && item.acf.required == true) {
        return item
      }
    })
    return output
  },
  filterAllSessionsByProp: (state, getters) => (
    array = [0],
    propKey = 'id',
  ) => {
    const collection = []
    let i = 0
    do {
      const item = getters['getAllSessions'].find(
        item => item[propKey] == array[i],
      )
      console.log(item)
      collection.push(typeof item != 'undefined' ? item : {})
      i++
    } while (i < array.length)
    return collection
  },
  // // does mediaType need to be a getter on post? looks like it is just checking something already returned from vuex
  // mediaType: state => post => {
  //   let type = 'other'
  //
  //   if (post.acf.media_type === 'video' || post.acf.video_url !== '') {
  //     type = 'video'
  //   } else if (post.acf.media_type === 'audio' || post.acf.audio_file) {
  //     type = 'audio'
  //   }
  //
  //   return type
  // }
}
